module.exports = __webpack_public_path__ + "img/110043.37566ccb.png";